export const PAGE_CONFIG = {
  "name": "CommonLogWrap",
  "config": {
    "logConfig": {
      "menuId": "",
      "pageId": "902201",
      "pageName": "Social Index",
      "extInfo": "Social Index",
      "pagePath": "/socialIndex"
    }
  },
  "children": [
    {
      "name": "FullScreenBtn",
      "children": [
        {
          "name": "SocialFilter",
          "props": {
            "rightTextEn": "Powered by AIX, Update Weekly",
            "rightTextCn": "由 AIX 提供支持, 周维度更新",
            "languageFilterConfig": {
              "defualt": [
                "global",
                "en",
                "de",
                "ja",
                "fr",
                "ko"
              ]
            }
          },
          "children": [
            {
              "name": "Insights",
              "children": [
                {
                  "name": "InsightsCard",
                  "titleEn": "Insights",
                  "titleCn": "洞察",
                  "normalNoContentEn": "No content available, please contact lynntzhou@global.tencent.com to add.",
                  "normalNoContentCn": " 当前无内容，请联系lynntzhou@global.tencent.com 添加"
                },
                {
                  "name": "InsightsEdit"
                }
              ]
            },
            {
              "name": "OverallIndex",
              "titleEn": "Overall Index",
              "titleCn": "总体指数",
              "tipContentEn": "The AiX Social Index evaluates brand performance across multiple brand components, scaling and weighting them appropriately to ensure comparability between products and regions. The Social Index is calculated as follows:Social Index = (brand assets * 0.25 + brand awareness * 0.25 + brand engagement * 0.25 + brand position * 0.25) * sqrt(brand sentiment),where brand assets are all relative conversion values referenced from Warframe Global.",
              "tipContentCn": "AiX 社媒指数基于缩放和加权评估品牌在多个品牌指标上的表现，确保游戏产品和地区之间的可比性。社媒指数的计算公式如下：社媒指数 = (品牌资产 * 0.25 + 品牌知名度 * 0.25 + 品牌互动量 * 0.25 + 品牌商业价值 * 0.25) * sqrt(品牌情感分)，其中品牌资产均参考 Warframe 全球 的相对换算值。"
            },
            {
              "name": "MetricsBreakdownTableService",
              "props": {
                "api": "/api/v2/dashboard/studio/game/social/metrics_breakdown",
                "formatData": (data: any) => {
                  const formattedData = JSON.parse(JSON.stringify(data));
                  formattedData.metrics_list.forEach(item => {
                    Object.keys(item.metrics).forEach(metricKey => {
                      const metric = item.metrics[metricKey];
                      if (metric.value && metric.value !== "") {
                        metric.value = parseFloat(metric.value).toFixed(1);
                      }
                    });
                  });
                  return formattedData;
                }
              },
              "children": [
                {
                  "name": "MetricsBreakdownTable",
                  "props": {
                    "titleEn": "Metrics Breakdown",
                    "titleCn": "细分指标",
                    "tipContentEn": "The default global benchmark is set at 100, with competitors' scores calculated relative to this standard. This standard is based on the average scores of all games during the first week of 2025(25.01.06 - 25.01.12). Scores for different languages are determined based on their global proportions. Please note that all facts apply exclusively to global data.",
                    "tipContentCn": "主游戏全球默认基准为 100，竞品游戏得分由该基准计算。此标准基于2025年第一周（1月6日至1月12日）所有游戏平均分数，不同语言的得分则根据其全球比例进行确定。详情部分描述仅针对于全球数据。"
                  }
                }
              ]
            },
            {
              "name": "HomeFooter",
              "className": "",
              "type": "layout",
              "style": {
                "bottom": "-29px",
                "left": "0"
              },
              "props": {
                "urls": [
                  "/studio/digital_extremes"
                ],
                "textEn": "If you have any questions or suggestions regarding this page, please contact xinxccheng@tencent.com.",
                "textCn": "如果您对本页面有任何问题或建议，请联系 xinxccheng@tencent.com。"
              }
            }
          ]
        }
      ]
    }
  ]
};